module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/wx08.6e62785.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newhome/wx08.png
// module id = DK5t
// module chunks = 0